// @ts-nocheck
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import noop from 'lodash/noop';
import { apiRequest, incaAccessor } from '@cancercentrum/inca';
import { Alert } from '@cancercentrum/rcc-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import withI18n from '../i18n/hoc';
import { IncaContext } from './ScopedIncaContext/IncaContext';
class ErrorBoundary extends PureComponent {
    static contextType = IncaContext;
    static defaultProps = {
        logError: true,
        renderError: (data)=>{
            const { error, info, t } = data;
            return /*#__PURE__*/ _jsx("section", {
                className: "error-boundary",
                children: /*#__PURE__*/ _jsxs(Alert, {
                    bsStyle: "danger",
                    children: [
                        /*#__PURE__*/ _jsxs("h2", {
                            children: [
                                /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                                    icon: faExclamationTriangle
                                }),
                                " ",
                                t('error.unexpected')
                            ]
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: error.message
                        }),
                        error.stack && /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    children: "Stack"
                                }),
                                /*#__PURE__*/ _jsx("pre", {
                                    children: error.stack
                                })
                            ]
                        }),
                        info.componentStack && /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    children: "Komponent-stack"
                                }),
                                /*#__PURE__*/ _jsx("pre", {
                                    children: info.componentStack
                                })
                            ]
                        })
                    ]
                })
            });
        }
    };
    constructor(){
        super();
        this.state = {};
    }
    componentDidCatch(error, info) {
        if (this.props.logError) {
            const ctx = this.context;
            if (ctx) {
                let source = 'unknown';
                if (ctx?.type === 'startpage') {
                    source = 'startPage';
                } else if (ctx?.type === 'form') {
                    source = 'form';
                }
                apiRequest('/JavascriptLogs/LogError', {
                    method: 'POST',
                    json: {
                        message: `${error.message}. Component Stack: ${info.componentStack}`,
                        stack: error.stack,
                        source,
                        designedFormId: ctx?.designedForm?.id,
                        registerRecordId: ctx?.registerRecord?.id,
                        errandId: ctx?.errand?.id,
                        documentId: ctx?.document?.id
                    }
                });
            } else {
                // Fallback till inca-objektet om nya contexten
                (incaAccessor()?.services?.logging?.logError || noop)({
                    message: `${error.message}. Component Stack: ${info.componentStack}`,
                    stack: error.stack
                });
            }
        }
        this.setState({
            error,
            info
        });
    }
    render() {
        const { error, info } = this.state;
        const { t } = this.props.i18n;
        if (error) {
            return this.props.renderError({
                error,
                info,
                t
            });
        }
        return this.props.children;
    }
}
export default withI18n()(ErrorBoundary);
